import * as R from 'ramda'

const getRaw = (key) => {
  const raw = localStorage.getItem(`OTA_${key}`)
  return raw !== 'undefined' ? raw : null
}

const Storage = {
  get (key, defaultValue = null) {
    const val = JSON.parse(getRaw(key))
    return R.ifElse(R.isNil, R.always(defaultValue), R.always(val))(val)
  },
  getNested (key, nestedKey, defaultValue = null) {
    const val = JSON.parse(getRaw(key))
    return R.ifElse(R.isNil, R.always(defaultValue), R.propOr(defaultValue, nestedKey))(val)
  },
  save (key, value) {
    return localStorage.setItem(`OTA_${key}`, JSON.stringify(value))
  },
  saveNested (key, nestedKey, value) {
    const val = JSON.parse(localStorage.getItem(`OTA_${key}`)) || {}
    val[nestedKey] = value
    return localStorage.setItem(`OTA_${key}`, JSON.stringify(val))
  },
  remove (key) {
    return localStorage.removeItem(`OTA_${key}`)
  },
  removeNested (key, nestedKey) {
    const val = JSON.parse(localStorage.getItem(`OTA_${key}`))
    delete val[nestedKey]
    return localStorage.setItem(`OTA_${key}`, JSON.stringify(val))
  },
}

export default Storage
